import React from 'react';
import { motion } from 'framer-motion';
const fleet = [{
  name: 'N-1 Vanguard',
  type: 'לוויין תצפית',
  weight: '150kg',
  orbit: 'LEO',
  img: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)'
}, {
  name: 'N-2 Sentinel',
  type: 'לוויין תקשורת',
  weight: '320kg',
  orbit: 'MEO',
  img: 'linear-gradient(135deg, #0f172a 0%, #064e3b 100%)'
}, {
  name: 'N-3 Explorer',
  type: 'גשושית חלל עמוק',
  weight: '850kg',
  orbit: 'HEO',
  img: 'linear-gradient(135deg, #0f172a 0%, #4c1d95 100%)'
}, {
  name: 'N-4 Cargo',
  type: 'רכב אספקה',
  weight: '2500kg',
  orbit: 'LEO',
  img: 'linear-gradient(135deg, #0f172a 0%, #7f1d1d 100%)'
}];
export function Fleet() {
  return <section id="fleet" className="py-24 relative z-10" data-id="element-38">
      <div className="max-w-7xl mx-auto px-6" data-id="element-39">
        <div className="flex justify-between items-end mb-12" data-id="element-40">
          <div data-id="element-41">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-42">
              צי{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400" data-id="element-43">
                החלליות
              </span>
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-44">
              פלטפורמות מודולריות המותאמות לכל משימה.
            </p>
          </div>
          <div className="hidden md:flex gap-2" data-id="element-45">
            <button className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors" data-id="element-46">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-47">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-48" />
              </svg>
            </button>
            <button className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors" data-id="element-49">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-50">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-51" />
              </svg>
            </button>
          </div>
        </div>

        <div className="flex overflow-x-auto pb-8 -mx-6 px-6 gap-6 snap-x hide-scrollbar" style={{
        scrollbarWidth: 'none'
      }} data-id="element-52">
          {fleet.map((craft, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="min-w-[300px] md:min-w-[350px] snap-center rounded-3xl overflow-hidden bg-[#0a0b14] border border-white/10 group cursor-pointer" data-id="element-53">
              <div className="h-48 w-full relative overflow-hidden" style={{
            background: craft.img
          }} data-id="element-54">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-20 mix-blend-overlay" data-id="element-55" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-56">
                  {/* Abstract craft representation */}
                  <div className="w-24 h-24 border border-white/30 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-500" data-id="element-57">
                    <div className="w-16 h-16 border border-white/50 rounded-full flex items-center justify-center" data-id="element-58">
                      <div className="w-8 h-8 bg-white/80 rounded-full shadow-[0_0_20px_white]" data-id="element-59" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-60">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-61">
                  {craft.name}
                </h3>
                <p className="text-cyan-400 text-sm font-medium mb-6" data-id="element-62">
                  {craft.type}
                </p>

                <div className="grid grid-cols-2 gap-4" data-id="element-63">
                  <div data-id="element-64">
                    <div className="text-gray-500 text-xs uppercase tracking-wider mb-1" data-id="element-65">
                      משקל
                    </div>
                    <div className="text-white font-mono" data-id="element-66">{craft.weight}</div>
                  </div>
                  <div data-id="element-67">
                    <div className="text-gray-500 text-xs uppercase tracking-wider mb-1" data-id="element-68">
                      מסלול
                    </div>
                    <div className="text-white font-mono" data-id="element-69">{craft.orbit}</div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}